import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12a9fe38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Rules")
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Nessun regolamento presente", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]

import {IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar} from '@ionic/vue';
import FileShower from "@/views/file/fileShower.vue";
import userService from "@/api/users/UserService";
import {computed, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentClass = JSON.parse(localStorage.getItem('currentClass') || '{}')

const {
  fetchUserSelectedClass
} = userService()

const fetchedRule = ref({ link: [] as string[] })

const ruleLinks = computed(() => {
  const link = fetchedRule.value && fetchedRule.value.link
  if (Array.isArray(link)) {
    return link
  }
  if (typeof link === 'string' && link.trim()) {
    return [link]
  }
  return []
})

fetchUserSelectedClass(currentClass).then(response => {
  fetchedRule.value = response.data.data.rule || { link: [] }
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton), { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "ion-padding",
            style: _normalizeStyle(_unref(ruleLinks).length === 0 ? 'display: flex; justify-content: center; align-items: center; height: 100%' : '')
          }, [
            (_unref(ruleLinks).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ruleLinks), (link) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: link,
                  src: link,
                  loading: "lazy"
                }, null, 8, _hoisted_5))
              }), 128))
            ])
          ], 4)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})